import { ReleaseCheckItem } from '../../types/ReleaseCheckItem'

export const hasDiscrepancies = (item: ReleaseCheckItem) =>
  item.status === 'DiscrepanciesFound' ||
  item.status === 'TargetMissing' ||
  item.status === 'Failed' ||
  item.discrepancies.length > 0 ||
  !!item.error

export const isCompliant = (item: ReleaseCheckItem) => item.status === 'Ok'

// Shared by ResultsTable (row filtering) and PanelNav (count badges) so both
// agree on what "visible" means under the current filters.
export const isItemVisible = (
  item: ReleaseCheckItem,
  includeIgnored: boolean,
  includeCompliant: boolean,
) => {
  if (!includeIgnored && item.ignored) return false
  if (isCompliant(item)) return includeCompliant
  // non-compliant: only show if it has discrepancies (excludes Pending with no findings)
  return hasDiscrepancies(item)
}
